import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px;
  background: #f5f5f5;
`;

const BrandingSection = styled.div`
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    color: #232323;
  }
`;

const Logo = styled.h1`
  font-size: 18px;
  line-height: 20px;
  font-weight: normal;
`;
const MenuSection = styled.div`
  margin-left: auto;
  display: flex;
`;

const Button = styled.button`
  display: block;
  font-size: 14px;
  padding: 0 16px;
  height: 32px;
  border-color: transparent;
  margin-left: 16px;
  border-color: ${props => (props.outline ? "#232323" : "transparent")};
  background: ${props => (props.outline ? "transparent" : "#232323")};
  color: ${props => (props.outline ? "#232323" : "#ffffff")};
  cursor: pointer;
  i {
    vertical-align: middle;
    margin-right: 4px;
    font-size: 20px;
  }
`;

const Header = ({ undo, redo, exportAsPNG }) => {
  return (
    <HeaderContainer>
      <BrandingSection>
        <Link to="/">
          <Logo>
            React <b>Image Editor</b>
          </Logo>
        </Link>
      </BrandingSection>

      <MenuSection>
        <Button
          onClick={e => {
            e.preventDefault();
            undo();
          }}
          outline
        >
          <i className="material-icons">undo</i> Undo
        </Button>
        <Button
          onClick={e => {
            e.preventDefault();
            redo();
          }}
          outline
        >
          <i className="material-icons">redo</i> Redo
        </Button>
        <Button
          onClick={e => {
            e.preventDefault();
            exportAsPNG();
          }}
        >
          <i className="material-icons">save_alt</i> Download
        </Button>
      </MenuSection>
    </HeaderContainer>
  );
};

export default Header;
